import $ from 'jquery';
import _ from 'underscore';
import App from '../app.js';
import ScrollMagic from 'scrollmagic';
import OrbitHelper from '../modules/OrbitHelper.js';
var Press = function() {
	var $section = $('#PressSection'),
			$orbit = $section;

	if( $section.length < 1 ) return false;

	var	$curve = $section.find('.js-curve'),
			$next = $section.find('.js-next'),
			sliderTemplate = _.template( $section.find('#PressItemTemplate').html() ),
			$currentSlider,
			isAnimating = false,
			scrollMagicController = App.getScrollMagicController(),
			enterScene,
			settings = {
				duration: 2.5
			};

			var pressData = window.pressList,
			totalEntries = pressData.length,
			currentEntry = 0;

	console.log('press init');

	// Create first news entry
	$currentSlider = createNewsEntryElement();
	currentEntry += 1;
	$orbit.append($currentSlider);

	// Create Scene
	createEnterScene();

	// Click Handlers

	$next.click(function(e){
		e.preventDefault();
		if( isAnimating ) return false;
		var $newSlider = createNewsEntryElement();
		$orbit.append($newSlider);


		// Tween Out Exit
		isAnimating = true;
		var exitTween = new TimelineMax({onComplete: exitComplete})
		// Transition Out $currentSlider
			.add(TweenMax.to($currentSlider, settings.duration * 0.35, {
					opacity: 0,
					bezier: {
						values: OrbitHelper.getExitBezierData($curve),
						curviness: 1.5
					},
					ease:Power2.easeInOut
				}), 'exit')
			// Tween in $newSlider
			.add(TweenMax.to($newSlider, settings.duration, {
					opacity: 1,
					bezier: {
						values: OrbitHelper.getEnterBezierData($curve),
						curviness: 1.5
					},
					ease:Power2.easeInOut
				}), 'exit')

			function exitComplete() {
				$currentSlider.remove();

				$newSlider.addClass('is-active');
				TweenLite.set($newSlider, {clearProps:"all"});

				// Update State
				$currentSlider = $newSlider;
				isAnimating = false;

				currentEntry += 1;
				if( currentEntry >= totalEntries) currentEntry = 0;
			}
		// Tween In New
	});

	function createNewsEntryElement() {
		// Get the current data
		var data = pressData[currentEntry];
		// Create New Element & add to orbit
		var sliderMarkup = sliderTemplate(data);
		var $newSlider = $( sliderMarkup );
		return $newSlider;
	}





	function createEnterScene() {

		// Set up Scroll Magic Scenes
		enterScene = new ScrollMagic.Scene({
			triggerElement: $section[0],
			triggerHook: "onEnter",
			duration: 0,
			offset: 0
		})
		.reverse(false)
		.addTo(scrollMagicController)
		// .addIndicators()
		.on('start', setEnterTween); // Create the tween when triggered
	}

	function setEnterTween() {
		var tween = new TimelineMax({onComplete: timelineComplete})
					.add(TweenMax.to($currentSlider, settings.duration, {
						opacity: 1,
						bezier: {
							values: OrbitHelper.getEnterBezierData($curve),
							curviness: 1.5
						},
						ease:Power2.easeOut
					}), 'enter');

					// .add(TweenMax.fromTo($slider, settings.duration * 0.5, { opacity: 0}, {opacity: 1, ease: Power2.easeOut}), 'enter');

		enterScene.setTween(tween);

		isAnimating = true;

		function timelineComplete() {
			tween.clear();
			tween.kill();
			TweenLite.set($currentSlider, {clearProps:"all"});
			$currentSlider.addClass('is-active');

			isAnimating = false;

			// Delete Enter Scene, Create Exit Scene
			// enterScene.destroy(true);
			// createExitScene();

			// Trigger callback if exists
			if (typeof settings.onAnimateInComplete === "function") settings.onAnimateInComplete($orbit);
		}
	}



};

export default Press();